import { RecoveryRecordBuilder } from "ags/integration/builders/records/recovery-record-builder";
import { ThemePickRecordBuilder } from "./theme-pick-record-builder";

export class ThemeRecoveryRecordBuilder extends RecoveryRecordBuilder {
    protected getPickRecordBuilder() {
        return new ThemePickRecordBuilder();
    }
}
